<template>
  <div>
    <div class="container mt-5" v-if="view == 'carrito'">
      <div
        id="div-modal-venta"
        style="margin-top: -15px"
        class="d-flex justify-content-center"
      >
        <div id="div-venta" class="card w-100">
          <div
            class="card-header text-white h5 text-center"
            style="background: #900052"
          >
            <strong>AGREGAR MEDICAMENTO - {{ patient }}</strong>
          </div>
          <div class="card-body" style="background-color: #e6e6e6">
            <div class="row">
              <div class="col-md-6" id="div-venta-body">
                <div class="col-md-12">
                  <div class="input-group input-group-sm mb-1">
                    <span
                      class="input-group-text"
                      style="background: #900052; color: #ffffff"
                      ><i class="fas fa-search"></i
                    ></span>
                    <input
                      type="search"
                      id="search_product"
                      class="form-control"
                      placeholder="Digitar Medicamento"
                      aria-describedby="search_product"
                      v-model="search_product"
                      @keyup="mtd_filter_product"
                    />
                  </div>
                </div>

                <div class="row py-1" id="list-product">
                  <div
                    v-for="(item, index) in data_product_filter"
                    :key="index"
                    class="col-md-12 py-1 d-flex align-items-center"
                    id="item-product"
                    style="background-color: #e6e6e6; height: 80px"
                  >
                    <div
                      class="p-1 d-flex flex-column w-100 justify-content-center"
                      style="background-color: #ffffff; height: 100%"
                      @click="mtdSelectSubsubcatergorie(item)"
                    >
                      <div class="align-items-center" id="name-product">
                        <p class="d-flex align-items-center mb-0 m-1">
                          <strong
                            class="mb-0 item-name custom-tooltip d-flex justify-content-between align-items-center"
                            data-toggle="tooltip"
                            :data-placement="'top'"
                            :title="item.name"
                            :class="{
                              'text-success': item.total_quantity > 5,
                              'text-danger': item.total_quantity == 0,
                              'text-custom-light-green':
                                item.total_quantity <= 5 &&
                                item.total_quantity > 0,
                            }"
                            style="
                              width: 88%;
                              margin-left: 10px;
                              font-size: 11.5px;
                              margin-top: 10px;
                            "
                          >
                            <div class="d-flex flex-column">
                              <span>{{ item.name }}</span>
                              <span
                                style="
                                  font-size: 12px;
                                  line-height: 1.2;
                                  font-weight: bold;
                                  color: rgba(
                                    var(--bs-success-rgb),
                                    var(--bs-text-opacity)
                                  ) !important;
                                "
                              >
                                Lote: {{ item.lote }} | Fec. venc.:
                                {{ item.fech }}
                              </span>
                            </div>
                            <span
                              style="
                                font-weight: bold;
                                font-size: 14px;
                                text-align: right;
                              "
                            >
                              ({{ item.total_quantity }})
                            </span>
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- carrito -->
              <div class="col-md-6 pt-3">
                <div class="col-md-12">
                  <div class="input-group input-group-sm mb-3">
                    <span
                      class="input-group-text rounded-pill w-100"
                      style="
                        background: #900052;
                        color: #ffffff;
                        padding-left: 25px;
                      "
                      ><strong>MEDICAMENTOS ESCOGIDOS</strong></span
                    >
                  </div>
                </div>
                <div class="col-md-12 list-monto">
                  <div class="container-list">
                    <div class="" v-if="carrito.length > 0">
                      <div
                        class="box item-monto"
                        v-for="(item, index) in carrito"
                        :key="index"
                      >
                        <div class="monto-container">
                          <div class="d-flex flex-column flex-grow-1">
                            <p class="text-monto mb-0">
                              {{ item.name }}
                            </p>
                            <small class="text-monto mb-0">
                              Lote: {{ item.dataRe.lote }} | Fec. venc.:
                              {{ item.dataRe.fech }} | Stock max.: {{ item.dataRe.stock_max }}
                            </small>
                          </div>

                          <button
                            type="button"
                            class="btn btn-sm btn-danger rounded-circle ms-2"
                            style="width: 30px; height: 30px; padding: 0"
                            title="Eliminar medicamento"
                            @click="mtdRemoveItem(index)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>

                        <div
                          class="d-flex align-items-center justify-content-end mt-2"
                          style="gap: 8px"
                        >
                          <span
                            class="text-monto"
                            style="font-size: 12px; font-weight: bold"
                            >CANTIDAD:</span
                          >

                          <button
                            type="button"
                            class="btn btn-sm btn-secondary rounded-circle"
                            style="width: 30px; height: 30px; padding: 0"
                            @click="mtdDecreaseQuantity(index)"
                          >
                            <i class="fas fa-minus text-white"></i>
                          </button>

                          <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control bg-white form-control-sm text-center"
                            style="width: 60px"
                            :value="item.dataRe.quantity_dispatch"
                            @input="mtdOnQuantityInput(index, $event)"
                            @keypress="mtdOnlyNumbers($event)"
                            @blur="mtdFixQuantityOnBlur(index)"
                          />

                          <button
                            type="button"
                            class="btn btn-sm btn-secondary rounded-circle"
                            style="width: 30px; height: 30px; padding: 0"
                            @click="mtdIncreaseQuantity(index)"
                          >
                            <i class="fas fa-plus text-white"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12"></div>
            </div>
          </div>
          <div
            class="card-footer text-white"
            style="background: #900052; font-size: 20px"
          >
            <div class="row">
              <div class="col" align="left">
                <span
                  class="btn border border-white text-white"
                  @click="retroceder"
                  ><strong>ATRAS</strong></span
                >
              </div>
              <div align="right" class="col">
                <span
                  class="btn border border-white text-white"
                  style="margin-left: 20px"
                  @click="mtdNextStep"
                  ><strong>OK</strong></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <CModal
      @mtdclosemodal="mtdCloseModalDoctor"
      :show="modalDoctor.boo_modal"
      :close-on-backdrop="false"
      :centered="true"
      title="Médico que prescribe"
      :size="'lg'"
      :btn_cancel="true"
      :btn_ok="true"
      :booTitile="true"
    >
      <div class="mb-3">
        <label class="form-label">Médico</label>

        <!-- v-select con múltiples capas de filtrado -->
        <v-select
          :key="doctorSelectKey"
          :options="filteredDoctors"
          label="fullname"
          :reduce="(doctor) => doctor.id"
          :filterable="false"
          placeholder="Buscar por nombre, CPM o RNE..."
          v-model="modalDoctor.doctor_id"
          class="v-select-doctors"
          @search="mtdOnDoctorSearch"
        >
          <!-- Opción en la lista -->
          <template #option="doctor">
            <div class="d-flex justify-content-between align-items-center w-100">
              <span>
                <strong>{{ doctor.fullname }}</strong>
              </span>
              <span class="d-flex">
                <span
                  v-if="doctor.cpm"
                  class="badge bg-secondary"
                  style="margin-left: 4px"
                >
                  CPM: {{ doctor.cpm }}
                </span>
                <span
                  v-if="doctor.rne"
                  class="badge bg-info text-dark"
                  style="margin-left: 4px"
                >
                  RNE: {{ doctor.rne }}
                </span>
              </span>
            </div>
          </template>

          <!-- Opción seleccionada -->
          <template #selected-option="doctor">
            <div class="d-flex justify-content-between align-items-center w-100">
              <span>
                <strong>{{ doctor.fullname }}</strong>
              </span>
              <span class="d-flex">
                <span
                  v-if="doctor.cpm"
                  class="badge bg-secondary"
                  style="margin-left: 4px"
                >
                  CPM: {{ doctor.cpm }}
                </span>
                <span
                  v-if="doctor.rne"
                  class="badge bg-info text-dark"
                  style="margin-left: 4px"
                >
                  RNE: {{ doctor.rne }}
                </span>
              </span>
            </div>
          </template>

          <!-- Sin resultados -->
          <template #no-options>
            No se encontraron médicos con ese criterio.
          </template>
        </v-select>
      </div>
      <template #footer>
        <button @click="mtdCloseModalDoctor" class="btn btn-danger btn-sm">
          <i class="fa fa-times" />&nbsp;Cancelar
        </button>
        <button class="btn btn-success btn-sm" @click="mtdConfirmDoctor()">
          <i class="fas fa-check"></i> Confirmar
        </button>
      </template>
    </CModal>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
export default {
  name: "c-pharmacy-cCarritoCli",
  components: {
    SweetAlert,
    CModal,
  },
  props: {
    recipe_id: {
      type: Number,
      default: 0,
    },
    patient_id: {
      type: Number,
      default: 0,
    },
    medical_act_id: {
      type: Number,
      default: 0,
    },
    hc_id: {
      type: Number,
      default: 0,
    },
    pageIni: String,
    patient: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      swal: null,
      view: "carrito",
      dataSubSubCategories: [],
      data_product_filter: [],
      search_product: "",
      carrito: [],
      item_carrito: {},
      posEditPrice: null,
      stock: [],
      dataDoctors: [],
      modalDoctor: {
        boo_modal: false,
        doctor_id: null,
      },
      doctorSelectKey: 0,       // key para forzar re-render del v-select
      doctorSearchTerm: "",     // término de búsqueda actual del doctor
    };
  },
  computed: {
    /**
     * Opciones filtradas manualmente del doctor (para forzar el filtrado).
     * Si no hay término de búsqueda, devuelve TODOS los doctores.
     */
    filteredDoctors() {
      if (!this.doctorSearchTerm) {
        return this.dataDoctors;
      }
      const term = this.doctorSearchTerm.toString().toLowerCase().trim();
      if (!term) return this.dataDoctors;

      return this.dataDoctors.filter((doctor) => {
        const fullname = (doctor.fullname || "").toLowerCase();
        const cpm = (doctor.cpm || "").toString().toLowerCase();
        const rne = (doctor.rne || "").toString().toLowerCase();

        return (
          fullname.includes(term) ||
          cpm.includes(term) ||
          rne.includes(term)
        );
      });
    },
  },
  created() {
    this.mtdGetDoctors();
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdGetDoctors: function () {
      this.get({
        url: this.$store.getters.get__url + "/Doctor",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataDoctors = response.data.map((doctor) => ({
            ...doctor,
            cpm: doctor.cpm || "",
            rne: doctor.rne || "",
            fullname: `${doctor.name || ""} ${doctor.last_name || ""}`.trim(),
          }));
          // Forzar re-render del v-select cuando lleguen los datos
          this.doctorSelectKey += 1;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    /**
     * Filtro custom para el v-select de médicos.
     * 3 capas de seguridad: trim, toString, y verificación de null.
     */
    customDoctorFilter: function (option, label, search) {
      if (!search) return true;

      const term = search.toString().toLowerCase().trim();
      if (!term) return true;

      const fullname = (option.fullname || "").toString().toLowerCase();
      const cpm = (option.cpm || "").toString().toLowerCase();
      const rne = (option.rne || "").toString().toLowerCase();

      return (
        fullname.includes(term) ||
        cpm.includes(term) ||
        rne.includes(term)
      );
    },

    /**
     * Listener del evento search de v-select.
     * Guarda el término de búsqueda actual.
     */
    mtdOnDoctorSearch: function (search, loading) {
      this.doctorSearchTerm = search || "";
    },

    retroceder() {
      this.$emit("mtdBack", this.pageIni);
    },

    mtdGetDataSubSubCategories: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Pharmacy/regRecipe/" +
          this.recipe_id +
          "/mtdGetCarrito?search_product=" +
          this.search_product,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataSubSubCategories = response.data;
          this.data_product_filter = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    mtd_filter_product: function () {
      if (search_product.value.length >= 5 && search_product.value != "") {
        let q = search_product.value.toString().toUpperCase();
        this.mtdGetDataSubSubCategories(q);
        this.data_product_filter = [];
        let i = 0;
        this.dataSubSubCategories.forEach((element) => {
          let name = element.name.toString().toUpperCase();
          if (name.includes(q)) {
            this.data_product_filter.push(element);
          }
        });
      } else {
        this.data_product_filter = this.dataSubSubCategories;
      }
    },

    mtdSelectSubsubcatergorie: function (item) {
      const existingItem = this.carrito.find(
        (element) => element.id == item.id
      );

      if (existingItem) {
        this.$refs.SweetAlert.showWarning(
          "Ya está agregado el Medicamento en el Carrito"
        );
        this.data_product_filter = [];
        this.search_product = "";
        return;
      }

      let nuevoItem = {
        id: item.id,
        name: item.name,
        q: 1,
        dataRe: {
          via: "",
          frecuencia: null,
          duracion: 1,
          total: "1",
          type: item.type,
          lote: item.lote,
          fech: item.fech,
          quantity_dispatch: 1,
          stock_max: Number(item.total_quantity) || 0,
          stock_id: item.stock_id,
          product_detail_id: item.product_detail_id,
          dispatch_detail_id: item.dispatch_detail_id,
        },
      };

      this.carrito.push(nuevoItem);
      this.data_product_filter = [];
      this.search_product = "";
    },

    mtdRemoveItem: function (index) {
      let item = this.carrito[index];
      this.$refs.SweetAlert.showConfirmSimple2(
        "Se eliminará: " + item.name,
        "¿Estás Seguro?",
        "warning",
        "Eliminar"
      ).then((result) => {
        if (result.value) {
          this.carrito.splice(index, 1);
        }
      });
    },

    mtdOnlyNumbers: function (event) {
      const key = event.key;
      if (!/[0-9]/.test(key)) {
        event.preventDefault();
      }
    },

    mtdOnQuantityInput: function (index, event) {
      let val = event.target.value.replace(/[^0-9]/g, "");
      val = val.replace(/^0+(?=\d)/, "");
      let num = val === "" ? "" : Number(val);

      let stock_max = Number(this.carrito[index].dataRe.stock_max) || 0;

      if (num !== "" && num > stock_max) {
        num = stock_max;
        val = String(stock_max);
        this.$refs.SweetAlert.showWarning(
          "El stock máximo disponible es " + stock_max + ". Se ajustó al máximo."
        );
      }

      let item = JSON.parse(JSON.stringify(this.carrito[index]));
      item.dataRe.quantity_dispatch = num;
      this.$set(this.carrito, index, item);

      event.target.value = val;
    },

    mtdFixQuantityOnBlur: function (index) {
      let val = this.carrito[index].dataRe.quantity_dispatch;
      let stock_max = Number(this.carrito[index].dataRe.stock_max) || 0;
      let num = Number(val);

      if (val === "" || val === null || val === undefined || num < 1) {
        let item = JSON.parse(JSON.stringify(this.carrito[index]));
        item.dataRe.quantity_dispatch = 1;
        this.$set(this.carrito, index, item);
      } else if (num > stock_max) {
        let item = JSON.parse(JSON.stringify(this.carrito[index]));
        item.dataRe.quantity_dispatch = stock_max;
        this.$set(this.carrito, index, item);
        this.$refs.SweetAlert.showWarning(
          "El stock máximo disponible es " + stock_max + ". Se ajustó al máximo."
        );
      }
    },

    mtdIncreaseQuantity: function (index) {
      let current = Number(this.carrito[index].dataRe.quantity_dispatch) || 0;
      let stock_max = Number(this.carrito[index].dataRe.stock_max) || 0;

      if (current >= stock_max) {
        this.$refs.SweetAlert.showWarning(
          "El stock máximo disponible es " + stock_max + "."
        );
        return;
      }

      let item = JSON.parse(JSON.stringify(this.carrito[index]));
      item.dataRe.quantity_dispatch = current + 1;
      this.$set(this.carrito, index, item);
    },

    mtdDecreaseQuantity: function (index) {
      let current = Number(this.carrito[index].dataRe.quantity_dispatch) || 0;
      if (current > 1) {
        let item = JSON.parse(JSON.stringify(this.carrito[index]));
        item.dataRe.quantity_dispatch = current - 1;
        this.$set(this.carrito, index, item);
      }
    },

    mtdNextStep: function () {
      if (this.carrito.length > 0) {
        this.modalDoctor.doctor_id = null;
        this.modalDoctor.boo_modal = true;
      } else {
        this.$refs.SweetAlert.showWarning("Seleccione un Medicamento");
      }
    },

    mtdCloseModalDoctor: function () {
      this.modalDoctor = {
        boo_modal: false,
        doctor_id: null,
      };
    },

    mtdConfirmDoctor: function () {
      if (!this.modalDoctor.doctor_id) {
        this.$refs.SweetAlert.showWarning("Seleccione el médico que prescribe");
        return;
      }
      const doctor_id = this.modalDoctor.doctor_id;
      this.mtdCloseModalDoctor();
      console.log("CARRITO ANTES DE EMITIR:", JSON.stringify(this.carrito, null, 2));
      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Estás Seguro?",
        "warning",
        "Confirmar"
      ).then((result) => {
        if (result.value) {
          this.$emit(
            "mtdSendCarrito",
            this.patient_id,
            this.medical_act_id,
            this.hc_id,
            this.recipe_id,
            this.carrito,
            doctor_id
          );
          this.carrito = [];
        }
      });
    },
  },
};
</script>

<style scoped>
.btn-home {
  z-index: 1;
}

.text-custom-light-green {
  color: #60d004;
}

#div-venta-body {
  height: 450px;
  overflow: auto;
  box-sizing: border-box;
  padding: 1rem 1rem;
}

#div-venta-body::-webkit-scrollbar {
  -webkit-appearance: none;
}

#div-venta-body::-webkit-scrollbar:vertical {
  width: 10px;
}

#div-venta-body::-webkit-scrollbar-button:increment,
#div-venta-body::-webkit-scrollbar-button {
  display: none;
}

#div-venta-body::-webkit-scrollbar:horizontal {
  height: 10px;
}

#div-venta-body::-webkit-scrollbar-thumb {
  background-color: #797979;
  border-radius: 20px;
  border: 2px solid #f1f2f3;
}

#div-venta-body::-webkit-scrollbar-track {
  border-radius: 10px;
}

#name-product {
  color: #8a8a97;
  font-size: 13px;
}

.list-doctor,
.list-monto {
  padding-right: 25px;
}

.text-doctor {
  color: #900052;
  font-size: 13px;
  font-weight: bold;
}

.text-monto {
  color: #900052;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 0px;
}

.container-list {
  margin: 30px;
  width: 100%;
}

.box {
  margin-bottom: 10px;
  position: relative;
}

.box::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 100%;
  background: #808080;
  left: -15px;
  top: 30px;
}

.box::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #900052;
  left: -23px;
  top: 10px;
}

.item-doctor,
.item-monto {
  padding: 10px 10px;
  border: #900052 3px solid;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.item-doctor:hover {
  cursor: pointer;
  background-color: #900052;
}

.item-doctor:hover p {
  color: #ffffff !important;
}

#item-product {
  align-items: center;
}

#item-product:hover {
  cursor: pointer;
  align-items: center;
  transform: scale(1.05);
}

.item-monto .input-group-text,
.item-monto .form-control {
  background-color: #fdfdfd !important;
  border: 0 !important;
  padding: 0px;
}

.item-monto .form-control button {
  background-color: #808080 !important;
  border: 0 !important;
}

.item-monto .form-control button:hover {
  background-color: #000000 !important;
  border: 0 !important;
}
.item-name {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-name strong {
  padding: 0px 10px;
  width: 120px;
}

.circulo {
  vertical-align: middle;
  border-style: none;
}

@media (max-width: 800px) {
  #btn-open-caja {
    justify-content: center !important;
  }

  #btn-registro-venta {
    text-align: center;
  }

  #div-tabla-venta {
    overflow-x: auto;
  }
}

@media (min-width: 800px) {
  #btn-registro-venta {
    text-align: left;
  }
}
#table-stock tbody tr:hover {
  background-color: #f3e2ec;
}
.monto-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Estilos del v-select de doctores */
.v-select-doctors .vs__dropdown-toggle,
.v-select-doctors .vs__dropdown-menu {
  width: 100% !important;
}

.v-select-doctors .vs__selected-options {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
}

.v-select-doctors .vs__selected {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.v-select-doctors .vs__dropdown-option {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.v-select-doctors {
  width: 100% !important;
}
</style>